import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarHeader,
  SidebarMenu,
  SidebarProvider,
  SidebarRail,
} from "ui/components/sidebar";
import { NavItem } from "@/components/nav/item";
import { Outlet, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectUser } from "store/src/slices/auth-slice";
import { useFetch } from "@/hooks/useFetch";
import { fetchEmployee } from "directus/src/operations";
import { CollapsibleSidebarHeader } from "@/components/nav/sidebar-header";
import { fullName, initials } from "components/employee/utils";
import { StatusDisplay } from "@/components/status/display";
import { INTEGRATIONS, RESPONSIBILITIES, USER } from "icons/src";

const CollapsibleEmployeeHeader = () => {
  const { employeeId } = useParams();
  const currentUser = useSelector(selectUser);

  const fields = [
    "id",
    "first_name",
    "last_name",
    "avatar",
    "job_title.name",
    "user.status",
  ];

  const { data: fetchedUser, isLoading } = useFetch({
    queryKey: ["user", "profile-header", employeeId],
    queryFn: () => fetchEmployee(employeeId, { fields }),
    enabled: !!employeeId,
  });

  const user = employeeId ? fetchedUser : currentUser;

  if (!user && !isLoading) {
    return null;
  }

  return (
    <CollapsibleSidebarHeader
      title={fullName(user)}
      // subtitle={
      //   user?.job_title?.name && (
      //     <span className="text-sm text-muted-foreground font-medium truncate max-w-full">
      //       {user.job_title.name}
      //     </span>
      //   )
      // }
      // subtitle={<StatusDisplay value={user.user?.status} />}
      logo={user?.avatar}
      fallbackText={initials(user)}
      isLoading={isLoading}
    />
  );
};

const MyProfileLayout = ({ baseUrl = "/profile", showIntegrations = true }) => {
  return (
    <>
      <SidebarProvider className="w-fit overflow-hidden max-h-dvh" name="my-profile">
        <Sidebar
          collapsible="icon"
          className="sidebar-height border-r left-auto inset-y-auto top-16"
        >
          <SidebarHeader className="p-0">

            <CollapsibleEmployeeHeader />

          </SidebarHeader>
          <SidebarContent>
            <SidebarGroup>
              <SidebarMenu>
                <NavItem title="About" url={`${baseUrl}/about`} icon={USER} />
                {showIntegrations && (
                  <NavItem title="Integrations" url={`${baseUrl}/integrations`} icon={INTEGRATIONS} />
                )}
                <NavItem title="Responsibilities" url={`${baseUrl}/responsibilities`} icon={RESPONSIBILITIES} />
              </SidebarMenu>
            </SidebarGroup>
          </SidebarContent>
          <SidebarRail />
        </Sidebar>
      </SidebarProvider>
      <Outlet />
    </>
  );
};

export default MyProfileLayout;

